import {
    Button,
    Card,
    CardActions,
    CardContent,
    CardMedia,
    Rating,
    Typography,Grid
  } from "@mui/material";
  import React, { useEffect, useState } from "react";
  import "./VideoCard.css";
  import { ConnectingAirportsOutlined, DataArrayRounded } from "@mui/icons-material";
  import moment from 'moment';
  import {  Link } from "react-router-dom";
  import { config } from "../App";
  import ThumbUpIcon from '@mui/icons-material/ThumbUp';
  import ThumbDownAltIcon from '@mui/icons-material/ThumbDownAlt';
  import { useParams } from "react-router-dom";
  import axios from "axios";
  import { useSnackbar } from "notistack";
  import { ToggleButton} from "@mui/material";
  import { styled } from "@mui/material/styles";
  import CircleIcon from '@mui/icons-material/Circle';
  import Iframe from 'react-iframe';

  const VideoCard = ({videoid}) => {
    const[Video, setVideo] = useState([]);
    const[upVote, setupVote]= useState(false);
    const[downVote,setdownVote]= useState(false);
    const { enqueueSnackbar } = useSnackbar();
    console.log("vieiodid", videoid);
    
    useEffect(() =>{

      getVideo(videoid);

    },[videoid]);


   const getVideo = async (videoid) => {
    console.log("vid", videoid);
      const url = config.endpoint+`/videos/${videoid}`;
      try {
        const res = await axios.get(url);
        setVideo(res.data);
        console.log("vedeos", res.data);
        return res.data;
      } catch (e) {
        if (e.response && e.response.data.message) {
          enqueueSnackbar(e.response.data.message, { variant: "error" });
          return null;
        } else {
          enqueueSnackbar("Something went wrong", { variant: "error" });
          return null;
        }
      }
    };

    const performancePatchcall = async ()=>{
      const url = config.endpoint+`/videos/${videoid}/views`;
      try {
        const res = await axios.patch(url);
        console.log("vedeos", res.data);
        return res.data;
      } catch (e) {
        if (e.response && e.response.data.message) {
          enqueueSnackbar(e.response.data.message, { variant: "error" });
          return null;
        } else {
          enqueueSnackbar("Something went wrong", { variant: "error" });
          return null;
        }
      }
    }
    useEffect(() =>{

      performancePatchcall();
    },[videoid]);

    const ColorButton = styled(Button)({
      textTransform: "capitalize",
      color: "#ffffff",
      fontsize: "1.5rem",
      border: "1px solid #444D56",
      borderRadius: "16px",
      boxShadow: "none",
      fontWeight: "400",
      marginRight:"0.5rem",
      "&.Mui-selected:hover": {
        backgroundColor: "#4CA3FC",
      },
     
      });
    const votePatchcall= async (data)=>{

      const url = config.endpoint+`/videos/${videoid}/votes`;
      try {
        const res = await axios.patch(url, data);
        console.log("vedeos", res.data);
        return res.data;
      } catch (e) {
        if (e.response && e.response.data.message) {
          enqueueSnackbar(e.response.data.message, { variant: "error" });
          return null;
        } else {
          enqueueSnackbar("Something went wrong", { variant: "error" });
          return null;
        }
      }

    }
   const uphandler = () =>{
    let tempupvote = upVote;
    tempupvote = !tempupvote;
    setupVote(tempupvote);

    if(upVote===true){
      let data = {"vote": "upVote",
      "change": "increase"}
      votePatchcall(data);
      getVideo(videoid);
    }
    else{
      let data = {"vote": "upVote",
      "change": "decrease"}
      votePatchcall(data);
      getVideo(videoid);
    }

   }

   const downhandler = () =>{
    let tempdownvote = downVote;
    tempdownvote = !tempdownvote;
    setdownVote(tempdownvote);

    if(downVote===true){
      let data = {"vote": "downVote",
      "change": "decrease"}
      votePatchcall(data);
      getVideo(videoid);
    }
    else{
      let data = {"vote": "downVote",
      "change": "increase"}
      votePatchcall(data);
      getVideo(videoid);
    }
  }

    return(
        <Grid container direction="column" justifyContent="space-between" marginBottom="1rem" color="white">
          <Grid>
          <Iframe url={`https://www.${Video.videoLink}`} width="100%" height="360" styles={{borderRadius:"10px", border:"0"}}/>
          {console.log("videolink", Video.videoLink)}
          </Grid>
        <Grid container justifyContent="space-between" marginTop="0.5rem">
          <Grid justifyContent="left" textAlign="left">
                <Grid item fontSize="1rem" fontWeight="700px" fontFamily="Roboto">
                {Video.title}
                </Grid>
                <Grid fontSize="0.8rem" marginTop=".5rem" fontWeight="400px" container direction="row" alignItems="center">
                <Grid item pr={1}>{Video.viewCount} Views {" "}</Grid>
                        <Grid item pr={1}>
                          <CircleIcon sx={{ fontSize: "0.5rem" }} />
                        </Grid>
                        <Grid item>
                          {moment(Video.releaseDate).fromNow()}
                        </Grid>
                </Grid>

            </Grid>
        
           <Grid item>
              <ColorButton variant = "contained" disableRipple
              startIcon={<ThumbUpIcon sx={{marginRight:"0.3rem"}}/>}
              sx={{backgroundColor:upVote ? "#4CA3FC":"#313131"}} 
              onClick={uphandler}
              >
              <Typography> {Video.votes && Video.votes.upVotes}</Typography>
              </ColorButton>
              <ColorButton variant = "contained" disableRipple
              startIcon={<ThumbDownAltIcon sx={{marginRight:"0.3rem"}}/>}
              sx={{backgroundColor:downVote ? "#4CA3FC":"#313131", marginRight:"0"}} 
              onClick={downhandler}
              >
              <Typography sx={{textAlign:"left"}}>{Video.votes && Video.votes.downVotes}</Typography>
              </ColorButton>
            
          </Grid>
        </Grid> 
        </Grid>

    )

  }
export default VideoCard;
